//import liraries
import React  from "react";
import { View, Modal, TouchableOpacity, StyleSheet, Image} from "react-native";
import { CreateResponsiveStyle, DEVICE_SIZES } from 'rn-responsive-styles'
import CustomButton from "./CustomButton";
import CImage from "./CImage";
import CText from "./CText";
import RootNavigation from "../utilities/RootNavigation";

// create a component
const CWelcomeModalKyvPending = ({ visible, onCloseModal, vehicleList }) => {
  const styles = useStyles();
  
  let headingText = "KYV (Know Your Vehicle) is pending for your vehicle(s)"
  let description = "KYV is mandatory under the NPCI’s NETC program. Complete your KYV to prevent your FASTag from getting deactivated."
  let closeButtonText = "Complete KYV"

  const onPressBanner = () =>{
    // RootNavigation.navigate("Profile/MyVehicles/UpdateKYV")
    if(vehicleList?.length > 1){
      RootNavigation.navigate("Profile/MyVehicles")
    }else{
      RootNavigation.navigate("Profile/MyVehicles/updateKyv",{vrn:vehicleList[0].vrn})
    }
    
  }
  return (
    <Modal
      animationType={"fade"}
      visible={true}
      transparent={true}
      onRequestClose={() => onCloseModal()}
    >
     <TouchableOpacity style={styles.overlayContainer} onPress={() => onCloseModal()} >
        <View style={styles.overlay}></View>
        <View style={styles.modalContainer}>
          <View style={styles.modalBody}>
            <TouchableOpacity style={styles.closeBtnWidget} onPress={() => onCloseModal()}>
              <CImage.CloseIcon1></CImage.CloseIcon1>
            </TouchableOpacity>
            <View style={{backgroundImage: "linear-gradient(270deg, #d14a27 0%, #e89b61 100%)", width:330, padding:15, borderRadius:6}}>
              <View style={{flexDirection:'row', justifyContent:'space-between', alignItems:'center',marginBottom:8}}>
                <CImage.WarningSignIcon ></CImage.WarningSignIcon>
                <CText.welcomeModalTitle style={{marginLeft:10}}>{headingText}</CText.welcomeModalTitle>
              </View>
              <CText.welcomeModalDesc>{description}</CText.welcomeModalDesc>
              <View style={styles.btnWidget}>
              <CustomButton
                onPress={() => onPressBanner()}
                color ="gray"
                style={{backgroundColor:"white", borderRadius:15, alignItems:'center',width:'100%',paddingVertical:8,fontSize:10,marginTop:5}}
                text={closeButtonText}
              />
            </View>
            </View>
            
           
          </View>
          
        </View>
        </TouchableOpacity>
      
    </Modal>
  );
};

export default CWelcomeModalKyvPending;

const useStyles = CreateResponsiveStyle(
  {
    overlayContainer: {
      height: "100%",
      width: "100%",
      alignItems: "center",
      justifyContent: "center",
    },
    overlay: {
      backgroundColor: "rgba(0,0,0,0.7)",
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      top: 0,
      zIndex: 99,
    },
    modalContainer: {
      height: "100%",
      width: "100%",
      position: "absolute",
      alignItems: "center",
      justifyContent: "center",
      zIndex:999
    },
    modalBody: {
      width: "90%",
      height: "100%",
      alignSelf: "center",
      borderRadius: 10,
      alignItems: "center",
      justifyContent: "center"
    },
    imageStyle:{ 
      width: 450,
      height: 450, 
      borderRadius: 10, 
      margin: 0, 
      padding: 0,
      alignSelf:'center', 
    },
    btnWidget:{
      width:300,
      marginTop:15,
    },
    closeBtnWidget:{
      marginLeft:455
    }
   
   
  },

  {
    [DEVICE_SIZES.LG]: {
      

    },
    [DEVICE_SIZES.MD]: {
      
    },
    [DEVICE_SIZES.SM]: {
      
      imageStyle:{ 
        width: 320,
        height: 320, 
      },
      btnWidget:{
        width:300,
      },
      closeBtnWidget:{
        marginLeft:325
      }
    },
    [DEVICE_SIZES.XS]: {
      btnWidget:{
        width:280,
      },
      imageStyle:{ 
        width: 250,
        height: 250,
      },
      closeBtnWidget:{
        marginLeft:255
      }

    },
  }
);

const styles = StyleSheet.create({
  
});

